import { render, staticRenderFns } from "./ClientContactForm.vue?vue&type=template&id=0be9a8c2&"
import script from "./ClientContactForm.vue?vue&type=script&lang=ts&"
export * from "./ClientContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports